import Vue from "vue";

export const chartEvents = new Vue();
